import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=2a5ed71f"
import script from "./side-menu.vue?vue&type=script&lang=js"
export * from "./side-menu.vue?vue&type=script&lang=js"
import style0 from "./side-menu.vue?vue&type=style&index=0&id=2a5ed71f&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/php7/hartovasilion.gr/public/site/hartovasilion/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5ed71f')) {
      api.createRecord('2a5ed71f', component.options)
    } else {
      api.reload('2a5ed71f', component.options)
    }
    module.hot.accept("./side-menu.vue?vue&type=template&id=2a5ed71f", function () {
      api.rerender('2a5ed71f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/side-menu/side-menu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/js/components/side-menu/side-menu.vue
// module id = ./src/js/components/side-menu/side-menu.vue
// module chunks = 4